import type { HttpClient } from './http';

export interface KlardatenCredentialsDto {
  hasKey: boolean;
  last4: string | null;
  defaultClientInstanceId: string | null;
  defaultProfileId: string | null;
}

export interface KlardatenInstance {
  id?: string;
  name?: string;
  consultant_number?: string;
  [key: string]: unknown;
}

export interface KlardatenProfile {
  id: string;
  profile_id: string;
  scope: 'organization' | 'user';
  name: string;
  is_default: boolean;
}

export function createKlardatenCredentialsApi(http: HttpClient) {
  const base = 'users/me';
  return {
    get: () =>
      http.get<KlardatenCredentialsDto>(`${base}/klardaten-credentials`),
    post: (data: { apiKey: string }) =>
      http.post<KlardatenCredentialsDto>(`${base}/klardaten-credentials`, data),
    patch: (data: {
      defaultClientInstanceId?: string | null;
      defaultProfileId?: string | null;
    }) =>
      http.patch<KlardatenCredentialsDto>(
        `${base}/klardaten-credentials`,
        data
      ),
    delete: () => http.delete<void>(`${base}/klardaten-credentials`),
    listInstances: () =>
      http.get<KlardatenInstance[]>(`${base}/klardaten-instances`),
    listProfiles: (instanceId: string) => {
      const params = new URLSearchParams({ instanceId });
      return http.get<KlardatenProfile[]>(
        `${base}/klardaten-profiles?${params.toString()}`
      );
    },
  };
}

export type KlardatenCredentialsApi = ReturnType<
  typeof createKlardatenCredentialsApi
>;
